import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

import { RecentlyViewedModel } from 'models';

export interface VipAndPropertyTypeBadgeProps {
  vipMessage: string;
  recentlyViewed: RecentlyViewedModel;
  isDatelessPdp: boolean;
}

export const VipAndPropertyTypeBadge: React.FC<VipAndPropertyTypeBadgeProps> = ({ vipMessage, recentlyViewed, isDatelessPdp }) =>
  (vipMessage || recentlyViewed) && !isDatelessPdp ? (
    <div className="uitk-cell all-cell-1-1 all-b-margin-one">
      {recentlyViewed && <RecentlyViewed recentlyViewed={recentlyViewed} />}
      <AbacusExperiment name="pwa_loyalty_VIP_badge">
        <AbacusControl>
          {recentlyViewed && vipMessage && <span className="uitk-type-300 uitk-type-bold all-x-margin-two">&#183;</span>}
          {vipMessage && <span className="uitk-type-300 uitk-type-medium listing-vip">{vipMessage}</span>}
        </AbacusControl>
        <AbacusVariant bucket={1} />
      </AbacusExperiment>
    </div>
  ) : null;

interface RecentlyViewedProps {
  recentlyViewed: RecentlyViewedModel;
  addSeparator?: string;
}

const RecentlyViewed: React.FC<RecentlyViewedProps> = ({ recentlyViewed }) => (
  <>
    {recentlyViewed.icon && (
      <UitkIcon
        name={recentlyViewed.icon}
        size={UitkIconSize.SMALL}
        className="pwa-theme--grey-700 all-cell-align-middle all-b-padding-half"
      />
    )}
    <span className="uitk-type-regular pwa-theme--grey-700 uitk-type-300 listing-recently-viewed">{recentlyViewed.message}</span>
  </>
);
